import React, {
  CSSProperties,
  FC, useRef,
} from 'react';
import {
  ButtonDiv, Column,
} from './Styles';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';
import { lang } from '../../../../../../../lib/utils/utils';

const Button: FC<Props> = ({
  children,
  callback,
  flowId,
  style,
}) => {
  const btnRef = useRef<any>();

  return (
    <Column>
      <ButtonDiv
        ref={btnRef}
        style={{ fontFamily: lang('Squad-Regular, Squad', 'PingFangSC-Regular, PingFang SC'), ...style }}
        onClick={() => {
          if (flowId) {
            // 如果已经点击过一次了，不允许再次点击
            if (TempFieldUtils.aiFlowIds.includes(flowId)) {
              return;
            }
            TempFieldUtils.aiFlowIds.push(flowId);
          }

          // 触发点击回调
          callback();

          try {
            if (btnRef.current && btnRef.current.style) {
              btnRef.current.style.transform = `scale(0.9)`;
            }
            setTimeout(() => {
              if (btnRef.current && btnRef.current.style) {
                btnRef.current.style.transform = `scale(1)`;
              }
            }, 50);
          } catch (e) {
            console.error(e);
          }
        }}
      >
        {children}
      </ButtonDiv>

      {/* 顶层div，点击后触发按钮点击，增加按钮的点击响应区域 */}
      <div
        onClick={() => {
          btnRef.current.click();
        }}
        style={{ height: 46, width: '400%', marginTop: -44 }}
      />
    </Column>
  );
};

export interface Props {
  children: any;
  callback: () => void;
  // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
  flowId?: string;
  showAnimation?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

export default Button;
